function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgHideOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.807 4.221c-.939.68-1.62 1.398-2.294 2.266-.58.765-.58 2.256-.013 3.013.713.917 1.416 1.651 2.408 2.354C4.382 12.897 6.078 13.5 8 13.5a8.529 8.529 0 0 0 3.395-.69l-.771-.772A7.566 7.566 0 0 1 8 12.5c-3.803 0-6-2.7-6.7-3.6-.3-.4-.3-1.4.002-1.8.353-.455 1.09-1.368 2.221-2.162l-.717-.717Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92 6.335a3.5 3.5 0 0 0 4.743 4.743l-.75-.752a2.5 2.5 0 0 1-3.24-3.24l-.753-.751ZM7.086 5.672l-.751-.751a3.5 3.5 0 0 1 4.744 4.744l-.752-.752a2.5 2.5 0 0 0-3.241-3.241Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.477 11.063c1.134-.793 1.872-1.708 2.228-2.163.296-.4.296-1.4-.004-1.8-.7-.9-2.902-3.6-6.7-3.6-.98 0-1.855.18-2.624.463l-.772-.772A8.524 8.524 0 0 1 8 2.5c1.92 0 3.615.603 5.09 1.646.992.703 1.699 1.44 2.41 2.354.565.753.567 2.239-.008 3.016-.687.877-1.36 1.585-2.298 2.264l-.717-.717Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.646 1.646a.5.5 0 0 1 .707 0l12 12a.5.5 0 0 1-.707.708l-12-12a.5.5 0 0 1 0-.708Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgHideOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgHideOutlinedIcon);
export default Memo;